<ion-spinner
  name="crescent"
  color="secondary"
  [style.width.px]="width/30"
  [style.height.px]="width/30"
  [style.margin-top.px]="(-width/30)/2"
  [style.margin-left.px]="(-width/30)/2"
  style="position: absolute; top: 50%; left: 50%"
></ion-spinner>